import { render, staticRenderFns } from "./guarantor.vue?vue&type=template&id=1b392028&"
import script from "./guarantor.vue?vue&type=script&lang=ts&"
export * from "./guarantor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports